import {createSlice} from '@reduxjs/toolkit';

import {Enum} from '../../types/Enum';
import {AsyncThunkState, getAsyncThunkReducer} from '../../utils/reduxThunkUtils';
import {calculateFromWithoutVat, calculateFromWithVat} from './actions';

// Required for declaration emit (TS4023): exported selectors' inferred types reference CommonState
export interface CommonState extends AsyncThunkState {
  paymentTypes: Enum[];
}

const initialState: CommonState = {
  loading: {},
  errors: {},
  paymentTypes: [],
};

const slice = createSlice({
  name: 'common',
  initialState,
  reducers: {},
  extraReducers(builder) {
    const {asyncThunkReducer, handleThunkStates} = getAsyncThunkReducer(builder);
    asyncThunkReducer(calculateFromWithVat.action);
    asyncThunkReducer(calculateFromWithoutVat.action);

    handleThunkStates();
  },
});

const {reducer} = slice;
export const commonReducer = reducer;
